<template>
  <div class="dropdown">
    <button
      class="btn btn-link text-muted p-2 comparison-context-menu__trigger"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <i class="bi bi-three-dots-vertical fs-5"></i>
    </button>
    <div class="dropdown-menu dropdown-menu-end comparison-context-menu">
      <button
        type="button"
        class="dropdown-item d-flex align-items-center gap-2"
        :disabled="!hasHistory"
        @click="$emit('toggle-trend')"
      >
        <i
          class="bi"
          :class="
            trendEnabled
              ? 'bi-toggle-on text-primary'
              : 'bi-toggle-off text-muted'
          "
        ></i>
        <span>{{ $t('groupsComparison.enableTrend') }}</span>
      </button>
      <button
        type="button"
        class="dropdown-item d-flex align-items-center gap-2"
        @click="$emit('toggle-sensitive')"
      >
        <i
          class="bi"
          :class="
            sensitiveVisible
              ? 'bi-toggle-on text-primary'
              : 'bi-toggle-off text-muted'
          "
        ></i>
        <span>{{ $t('groupsComparison.showSensitive') }}</span>
      </button>
      <button
        type="button"
        class="dropdown-item d-flex align-items-center gap-2"
        @click="$emit('open-group-selector')"
      >
        <i class="bi bi-diagram-3"></i>
        <span>{{ $t('groupsComparison.selectTableGroups') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComparisonContextMenu',
  props: {
    hasHistory: {
      type: Boolean,
      default: false
    },
    trendEnabled: {
      type: Boolean,
      default: false
    },
    sensitiveVisible: {
      type: Boolean,
      default: true
    }
  },
  emits: ['toggle-trend', 'toggle-sensitive', 'open-group-selector']
}
</script>

<style scoped lang="scss">
.comparison-context-menu__trigger {
  i {
    transition: color 0.2s ease;
  }
  &:hover {
    i {
      color: var(--kt-primary) !important;
    }
  }
}

.comparison-context-menu {
  .dropdown-item {
    &:active {
      color: var(--kt-dropdown-link-color);
      background-color: var(--kt-dropdown-link-hover-bg);
    }
    .bi {
      font-size: 1.1rem;
    }
  }
}
</style>
